import { render, staticRenderFns } from "./TaskSuperActions.vue?vue&type=template&id=2505a5c6&scoped=true"
import script from "./TaskSuperActions.vue?vue&type=script&lang=ts"
export * from "./TaskSuperActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505a5c6",
  null
  
)

export default component.exports